module.exports = __webpack_public_path__ + "img/ring_y_c_1_1@3x.2395fdfb.png";